import { api } from "../../services/NetworkBase";

export async function GetTemperatureRecords() {
  try {
    let response = await api.get(`temperature-tracker`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTemperatureRecordsByCriteria(startDate, endDate, equipment, searchText, analysts = "") {
  try {
    let response = await api
      .get(`temperature-tracker/criteria?startDate=${startDate}&endDate=${endDate}&equipment=${equipment}&searchText=${searchText}&analysts=${encodeURIComponent(analysts)}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTemperatureRecordById(id) {
  try {
    let response = await api.get(`temperature-tracker/${id}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveTemperatureRecord(temperatureRecord) {
  try {
    let response = await api
      .post("temperature-tracker", { json: temperatureRecord })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateTemperatureRecord(temperatureRecord) {
  try {
    let response = await api
      .put("temperature-tracker", { json: temperatureRecord })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetTodayReadingCount(equipment, date) {
  try {
    let response = await api.get(`temperature-tracker/reading-count?equipment=${encodeURIComponent((equipment || "").trim())}&date=${date || ""}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteTemperatureRecord(id) {
  try {
    const encodedUrl = encodeURIComponent(id);
    let response = await api
      .delete(`temperature-tracker/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}